import { ref, type Ref } from 'vue';
import type { FrontendPopupInfoInputType, FrontendPopupInfoOutputType } from '@/gql/graphql';

const pendingRequestFrontendPopupInfo: Ref<FrontendPopupInfoInputType | null> = ref(null);
const frontendPopupInfoCtx: Ref<FrontendPopupInfoOutputType | null> = ref(null);

export const requestFrontendPopupInfo = (input: FrontendPopupInfoInputType) => {
  pendingRequestFrontendPopupInfo.value = input;
};

export const clearFrontendPopupInfoContext = () => {
  pendingRequestFrontendPopupInfo.value = null;
  frontendPopupInfoCtx.value = null;
};

export const useFrontendPopupInfoContext = () => ({
  pendingRequestFrontendPopupInfo,
  frontendPopupInfoCtx,
  requestFrontendPopupInfo,
  clearFrontendPopupInfoContext,
});
